import { NgModule } from '@angular/core';
import { ConfigurationsTooltipPipe } from './configurations-tooltip.pipe';
import { HasConfigurationsChangedPipe } from './has-configuration-changes.pipe';
import { CountEntityTypesPipe } from './count-entity-types.pipe';
import { ConfigurationNamesPipe } from './configuration-names.pipe';


@NgModule({
  declarations: [
    ConfigurationsTooltipPipe,
    HasConfigurationsChangedPipe,
    CountEntityTypesPipe,
    ConfigurationNamesPipe
  ],
  exports: [
    ConfigurationsTooltipPipe,
    HasConfigurationsChangedPipe,
    CountEntityTypesPipe,
    ConfigurationNamesPipe
  ],
})
export class ConfigurationsPipesModule {
}
